export * from './user.component';



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/users/index.ts